import React, { useState, useRef, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
// import { useLocation, useHistory } from 'react-router-dom';

import { signOut } from '../../../../redux/auth/auth.actions';

import { useDeviceType } from '../../../../hooks/useDeviceType.ts';

import ClientPortal from '../../../../components/ClientPortal/ClientPortal';


// import { useShortKeysNavigation } from '../../../../hooks/useShortKeysNavigation';

import {
    changeTheme,
} from '../../../../redux/diagram/diagram.actions';


import {
    selectThemeMode,
} from '../../../../redux/diagram/diagram.selectors';

import {
    selectIsSidebarCollapsed,
    selectIsSidebarProfileMenuEnabled,
    selectIsModalPricingPlanUpgradeEnabled,
    selectIsModalInvitePeopleEnabled,
    selectIsSidebarWorkspaceMenuEnabled,
} from '../../../../redux/main/main.selectors';

import {
    toggleSidebarCollapse,
    toggleSidebarProfileMenu,
    togglePricingPlanUpgrade,
    toggleInvitePeople,
    toggleSidebarWorkspaceMenu,
} from '../../../../redux/main/main.actions';


import {
    ModeDarkIcon,
    ModeLightIcon,
} from '../../../../components/Icon';

import { selectAuthUser } from '../../../../redux/auth/auth.selectors';
import {
    selectCurrentWorkspace,
    selectWorkspacePlan,
    selectWorkspaceMembers,
} from '../../../../redux/workspace/workspace.selectors';

import { trackEvent } from '../../../../lib/analytics';

import './Sidebar.scss';

const Sidebar = () => {
    const { isDesktop } = useDeviceType(); // mobile/tablet => false

    const dispatch = useDispatch();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    // const { map: shortKeysMap } = useShortKeysNavigation();

    const isLightTheme = useSelector(selectThemeMode);

    const isSidebarCollapsed = useSelector(selectIsSidebarCollapsed);
    const isSidebarCollapsedRef = useRef(null);

    const isSidebarProfileMenuEnabled = useSelector(selectIsSidebarProfileMenuEnabled);

    const isModalPricingPlanUpgradeEnabled = useSelector(selectIsModalPricingPlanUpgradeEnabled);
    const isModalInvitePeopleEnabled = useSelector(selectIsModalInvitePeopleEnabled);
    const isSidebarWorkspaceMenuEnabled = useSelector(selectIsSidebarWorkspaceMenuEnabled);

    const currentUser = useSelector(selectAuthUser);
    const workspace = useSelector(selectCurrentWorkspace);
    const workspacePlan = useSelector(selectWorkspacePlan) || 'free';
    const workspaceMembers = useSelector(selectWorkspaceMembers) || [];

    const workspaceName = workspace?.name || 'My Workspace';
    const workspaceInitial = workspaceName[0].toUpperCase();
    const workspacePlanLabel = workspacePlan.charAt(0).toUpperCase() + workspacePlan.slice(1);

    useEffect(() => {
        isSidebarCollapsedRef.current = isSidebarCollapsed;
    }, [isSidebarCollapsed]);

    // Перемикаємо стан сайдбара
    const toggleSidebar = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleClickMenuItem = (menuItem = '') => {
        trackEvent(`app_sidebar_${menuItem}`, {
            page: 'app',
            type: 'sidebar',
        });
    };

    const openInvitePeopleModal = () => {
        trackEvent('app_sidebar_invite_people', {
            page: 'app',
            type: 'sidebar',
        });
        dispatch(toggleInvitePeople({}));
    };

    const openUpgradePlanModal = () => {
        trackEvent('app_sidebar_upgrade_plan', {
            page: 'app',
            type: 'sidebar',
        });
        dispatch(togglePricingPlanUpgrade('main'));
    };

    const toggleProfileMenu = () => {
        trackEvent('app_sidebar_profile', {
            page: 'app',
            type: 'sidebar',
        });
        dispatch(toggleSidebarProfileMenu({}));
    };

    const toggleWorkspaceMenu = () => {
        trackEvent('app_sidebar_workspace', {
            page: 'app',
            type: 'sidebar',
        });
        dispatch(toggleSidebarWorkspaceMenu({}));
    };

    const toggleSidebarCollapsed = () => {
        trackEvent('app_sidebar_collapse', {
            page: 'app',
            type: 'sidebar',
        });
        dispatch(toggleSidebarCollapse(!isSidebarCollapsedRef.current));
    };

    const toggleTheme = (themeValue) => {
        dispatch(changeTheme(themeValue));
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && (e.key.toLowerCase() === 'b') || (e.ctrlKey && e.code === "KeyB")) {
                e.preventDefault(); // запобігає браузерним діям (наприклад, жирному шрифту)
                toggleSidebarCollapsed();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);



    const handleMobileMenuClick = (menuItem = '') => {
        setIsMobileMenuOpen(false);

        trackEvent(`app_sidebar_${menuItem}`, {
            page: 'app',
            type: 'sidebar',
            subtype: 'mobile_menu',
        });
    }

    const handleMobileInvitePeopleClick = () => {
        trackEvent('app_sidebar_invite_people', {
            page: 'app',
            type: 'sidebar',
            subtype: 'mobile_menu',
        });
        // setIsMobileMenuOpen(false);
        openInvitePeopleModal();
    }
    const handleMobileUpgradeClick = () => {
        // setIsMobileMenuOpen(false);
        openUpgradePlanModal();
    }
    const handleMobileSignOutClick = () => {
        setIsMobileMenuOpen(false);
        dispatch(signOut());
    }

    const handleHamburgerClick = () => {
        setTimeout(() => {
            setIsMobileMenuOpen(!isMobileMenuOpen);
        }, 125);
    }

    const handleLogoClick = () => {
        trackEvent('app_sidebar_logo', {
            page: 'app',
            type: 'sidebar',
            subtype: 'mobile_menu',
        });
        setTimeout(() => {
            setIsMobileMenuOpen(false);
        }, 125);
    }

    return (
        <div className={`dash-sidebar-wrap ${isMobileMenuOpen ? "open" : ""} ${isSidebarCollapsed ? 'collapsed' : ''} ${isLightTheme ? 'light' : ''}`}>

            {!isDesktop ?
                <header className="sidebar_header_wrap" id="header">
                    <div className="sidebar_header">
                        <NavLink to="/diagrams/" className="header_logo" aria-label="DB Design home" onClick={() => handleLogoClick()}>
                            <div></div>
                            <span className="header_logo_text">dbdesign.</span>
                        </NavLink>

                        <div className="header_action_buttons">
                            <button
                                // ref={btnBurgerRef}
                                className={`header_burger ${isMobileMenuOpen ? 'open' : ''}`}
                                aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
                                aria-controls="collapsed-header-items"
                                aria-expanded={isMobileMenuOpen}
                                // onClick={() => setOpen(o => !o)}
                                onClick={() => handleHamburgerClick()}
                            >
                                <svg width="28" height="28" viewBox="0 0 24 24" aria-hidden>
                                    {isMobileMenuOpen ? (
                                        <path d="M6 6l12 12M18 6L6 18" stroke="white" strokeWidth="1.75" strokeLinecap="round" />
                                    ) : (
                                        <path d="M4 6h16M4 12h16M4 18h16" stroke="white" strokeWidth="1.75" strokeLinecap="round" />
                                    )}
                                </svg>
                            </button>
                        </div>
                    </div>
                </header>
                : ''
            }




            {/* Mobile overlay + panel */}
            {!isDesktop && isMobileMenuOpen ?
                <ClientPortal>
                    <div
                        className="header_mobile_overlay"
                        data-open={isMobileMenuOpen ? 'true' : 'false'}
                        onClick={() => setIsMobileMenuOpen(false)}
                        aria-hidden={!isMobileMenuOpen}
                    />
                    <aside
                        // ref={panelRef}
                        id="collapsed-header-items"
                        className="header_mobile_panel"
                        data-open={isMobileMenuOpen ? 'true' : 'false'}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="mobile-menu-title"
                    >
                        <div className="header_mobile_panel_inner">
                            <div className="header_mobile_group product">
                                <div className="header_mobile_title" id="mobile-menu-title">Product</div>
                                <nav className="header_mobile_nav" aria-label="Mobile">
                                    {/* <a className="header_mobile_link selected" href="#features" onClick={() => { handleMobileMenuClick('diagrams') }}>Diagrams</a> */}
                                    <NavLink to="/diagrams/" className={({ isActive }) => isActive ? 'header_mobile_link selected' : 'header_mobile_link'} onClick={() => { handleMobileMenuClick('diagrams') }}>Diagrams</NavLink>
                                    <NavLink to="/templates/" className={({ isActive }) => isActive ? 'header_mobile_link selected' : 'header_mobile_link'} onClick={() => { handleMobileMenuClick('templates') }}>Templates</NavLink>
                                    <NavLink to="/integrations/" className={({ isActive }) => isActive ? 'header_mobile_link selected' : 'header_mobile_link'} onClick={() => { handleMobileMenuClick('integrations') }}>Integrations</NavLink>
                                    {/* <NavLink to="/subscriptions/" className={({ isActive }) => isActive ? 'header_mobile_link selected' : 'header_mobile_link'} onClick={() => { handleMobileMenuClick('subscriptions') }}>Subscriptions</NavLink> */}
                                    {/* <NavLink to="/guides-shortcuts/" className={({ isActive }) => isActive ? 'header_mobile_link selected' : 'header_mobile_link'} onClick={() => { handleMobileMenuClick('guides') }}>Guides & Shortcuts</NavLink> */}
                                </nav>
                            </div>
                            <div className="header_mobile_group">
                                <div className="header_mobile_title" id="mobile-menu-title">Other Actions</div>
                                <nav className="header_mobile_nav" aria-label="Mobile">
                                    <NavLink to="/support-feedback/" className={({ isActive }) => isActive ? 'header_mobile_link selected' : 'header_mobile_link'} onClick={() => { handleMobileMenuClick('feedback') }}>Support & Feedback</NavLink>
                                    <NavLink to="/settings/" className={({ isActive }) => isActive ? 'header_mobile_link selected' : 'header_mobile_link'} onClick={() => { handleMobileMenuClick('settings') }}>Settings</NavLink>
                                </nav>
                            </div>
                            <div className="header_mobile_group email">
                                {/* <div className="header_mobile_title email" id="mobile-menu-title">emily.nguyen@gmail.com</div> */}
                                <div className="header_mobile_title email" id="mobile-menu-title">{currentUser?.name || currentUser?.email}</div>


                                <nav className="header_mobile_nav" aria-label="Mobile">
                                    <NavLink to="/settings/profile/" className={'header_mobile_link none'} onClick={() => { handleMobileMenuClick('view_profile') }}>View Profile</NavLink>
                                    {/* <NavLink to="/guides-shortcuts/onboarding" className={'header_mobile_link none'} onClick={() => { handleMobileMenuClick('onboarding') }}>Onboarding</NavLink> */}
                                    {/* <NavLink to="/settings/" className={({ isActive }) => isActive ? 'header_mobile_link selected' : 'header_mobile_link'} onClick={() => { handleMobileMenuClick('signout') }}>Sign Out</NavLink> */}
                                    <a className="header_mobile_link" onClick={() => { handleMobileSignOutClick(); }}>Sign Out</a>

                                </nav>
                            </div>
                            <div className="header_mobile_actions">
                                <a className="header_mobile_btn secondary" onClick={() => { handleMobileInvitePeopleClick(); }}>Invite People</a>
                                {/* <a className="header_mobile_btn primary" onClick={() => { handleMobileUpgradeClick(); }}>Upgrade Plan</a> */}
                            </div>
                        </div>
                    </aside>
                </ClientPortal>
                : ''
            }

            {isDesktop ?
                <React.Fragment>
                    <div className="dash-sidebar-logo-wrap">
                        <div className="dash-sidebar-logo">
                            {/* <svg className="dash-sidebar-logo-icon header-logo-icon" fill="#000000" width="32px" height="36px" viewBox="0 0 82.626 82.627">
                        <path d="M5.206,19.956l0.199,42.771c0.003,0.55,0.306,1.054,0.789,1.314l34.161,17.887c0.223,0.119,0.467,0.179,0.711,0.179 c0.001,0,0.002,0,0.003,0c0.103,0.117,0.218,0.227,0.355,0.309c0.236,0.141,0.502,0.212,0.769,0.212 c0.246,0,0.49-0.061,0.712-0.181l33.729-18.292c0.484-0.263,0.787-0.77,0.787-1.319v-44.5c0-0.013-0.005-0.025-0.005-0.039 c-0.001-0.011,0.003-0.021,0.003-0.033c-0.002-0.043-0.019-0.082-0.022-0.124c-0.013-0.082-0.022-0.164-0.047-0.243 c-0.018-0.055-0.041-0.104-0.064-0.157c-0.031-0.07-0.062-0.139-0.104-0.203c-0.031-0.05-0.068-0.095-0.105-0.141 c-0.047-0.058-0.096-0.112-0.152-0.163c-0.044-0.04-0.091-0.076-0.141-0.111c-0.032-0.022-0.059-0.053-0.094-0.073 c-0.032-0.02-0.069-0.028-0.104-0.045c-0.029-0.015-0.052-0.036-0.081-0.049L41.747,0.118c-0.405-0.171-0.864-0.155-1.258,0.042 L6.131,18.071c-0.504,0.254-0.822,0.77-0.825,1.333c0,0.009,0.004,0.017,0.004,0.025C5.249,19.596,5.205,19.772,5.206,19.956z M72.456,18.501l-30.28,16.93L10.111,19.425L41.218,3.151L72.456,18.501z M43.692,78.61V38.021l30.729-17.173v41.09L43.692,78.61z"></path>
                    </svg> */}
                            {/* <span className="dash-sidebar-logo-text">dbdesign.</span> */}
                            {/* <span className="dash-sidebar-logo-paid">Free</span> */}

                            <div
                                // className="dash-sidebar-logo-workspace"
                                className={`dash-sidebar-logo-workspace ${isSidebarWorkspaceMenuEnabled ? 'active' : ''}`}
                                onClick={toggleWorkspaceMenu}
                            >
                                <div className="dash-sidebar-logo-workspace-avatar">{workspaceInitial}</div>
                                <div className="dash-sidebar-logo-workspace-info">
                                    <span className="dash-sidebar-logo-workspace-name">{workspaceName}</span>
                                    <span className="dash-sidebar-logo-workspace-plan">{workspacePlanLabel}</span>
                                </div>
                                {/* <svg className="dash-sidebar-logo-workspace-chevron" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9L12 15L18 9"></path></svg> */}
                                <svg className="dash-sidebar-logo-workspace-icon" fill="#000000" width="64px" height="64px" viewBox="0 0 1024 1024"><g><path d="M620.6 562.3l36.2 36.2L512 743.3 367.2 598.5l36.2-36.2L512 670.9l108.6-108.6zM512 353.1l108.6 108.6 36.2-36.2L512 280.7 367.2 425.5l36.2 36.2L512 353.1z"></path></g></svg>
                            </div>

                        </div>
                    </div>
                    <div className="dash-sidebar">
                        <div className="dash-sidebar-top">
                            <div className="menu-item-wrap">
                                <NavLink to="/diagrams/" className={({ isActive }) => isActive ? 'menu-item-link active' : 'menu-item-link'} onClick={() => handleClickMenuItem('diagrams')}>
                                    <div className="menu-item">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                                        <span>Diagrams</span>
                                        {/* <span>Diagrams</span> */}
                                    </div>
                                </NavLink>
                            </div>

                            <div className="menu-item-wrap">
                                <NavLink to="/templates/" className={({ isActive }) => isActive ? 'menu-item-link active' : 'menu-item-link'} onClick={() => handleClickMenuItem('templates')}>
                                    <div className="menu-item">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><path d="M8.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V8.4C3 8.96005 3 9.24008 3.10899 9.45399C3.20487 9.64215 3.35785 9.79513 3.54601 9.89101C3.75992 10 4.03995 10 4.6 10H8.4C8.96005 10 9.24008 10 9.45399 9.89101C9.64215 9.79513 9.79513 9.64215 9.89101 9.45399C10 9.24008 10 8.96005 10 8.4V4.6C10 4.03995 10 3.75992 9.89101 3.54601C9.79513 3.35785 9.64215 3.20487 9.45399 3.10899C9.24008 3 8.96005 3 8.4 3Z"></path><path d="M19.4 3H15.6C15.0399 3 14.7599 3 14.546 3.10899C14.3578 3.20487 14.2049 3.35785 14.109 3.54601C14 3.75992 14 4.03995 14 4.6V8.4C14 8.96005 14 9.24008 14.109 9.45399C14.2049 9.64215 14.3578 9.79513 14.546 9.89101C14.7599 10 15.0399 10 15.6 10H19.4C19.9601 10 20.2401 10 20.454 9.89101C20.6422 9.79513 20.7951 9.64215 20.891 9.45399C21 9.24008 21 8.96005 21 8.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3Z"></path><path d="M19.4 14H15.6C15.0399 14 14.7599 14 14.546 14.109C14.3578 14.2049 14.2049 14.3578 14.109 14.546C14 14.7599 14 15.0399 14 15.6V19.4C14 19.9601 14 20.2401 14.109 20.454C14.2049 20.6422 14.3578 20.7951 14.546 20.891C14.7599 21 15.0399 21 15.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V15.6C21 15.0399 21 14.7599 20.891 14.546C20.7951 14.3578 20.6422 14.2049 20.454 14.109C20.2401 14 19.9601 14 19.4 14Z"></path><path d="M8.4 14H4.6C4.03995 14 3.75992 14 3.54601 14.109C3.35785 14.2049 3.20487 14.3578 3.10899 14.546C3 14.7599 3 15.0399 3 15.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H8.4C8.96005 21 9.24008 21 9.45399 20.891C9.64215 20.7951 9.79513 20.6422 9.89101 20.454C10 20.2401 10 19.9601 10 19.4V15.6C10 15.0399 10 14.7599 9.89101 14.546C9.79513 14.3578 9.64215 14.2049 9.45399 14.109C9.24008 14 8.96005 14 8.4 14Z"></path></svg>
                                        <span>Templates</span>
                                    </div>
                                </NavLink>
                            </div>

                            <div className="menu-item-wrap">
                                <NavLink to="/integrations/" className={({ isActive }) => isActive ? 'menu-item-link active' : 'menu-item-link'} onClick={() => handleClickMenuItem('integrations')}>

                                    <div className="menu-item">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><path d="M5 21V14M5 10V3M12 21V12M12 8V3M19 21V16M19 12V3M2 14H8M9 8H15M16 16H22"></path></svg>
                                        <span>Integrations</span>
                                    </div>
                                </NavLink>
                            </div>

                            {/* <div className="horizontal-line"></div> */}

                            {/* <div className="menu-item-wrap">
                        <NavLink to="/teams-access/" className={({ isActive }) => isActive ? 'menu-item-link active' : 'menu-item-link'} onClick={() => handleClickMenuItem('teams')}>

                            <div className="menu-item">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                                <span>Teams & Access</span>
                            </div>
                        </NavLink>
                    </div> */}

                            {/* TODO: return after adding subscriptions */}
                            {/* <div className="menu-item-wrap">
                                <NavLink to="/subscriptions/" className={({ isActive }) => isActive ? 'menu-item-link active' : 'menu-item-link'} onClick={() => handleClickMenuItem('subscriptions')}>

                                    <div disabled className="menu-item disabled">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11.4999L11 13.4999L15.5 8.99987M20 11.9999C20 16.9083 14.646 20.4783 12.698 21.6147C12.4766 21.7439 12.3659 21.8085 12.2097 21.842C12.0884 21.868 11.9116 21.868 11.7903 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V7.21747C4 6.41796 4 6.0182 4.13076 5.67457C4.24627 5.37101 4.43398 5.10015 4.67766 4.8854C4.9535 4.64231 5.3278 4.50195 6.0764 4.22122L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999Z"></path></svg>
                                        <span>Subscriptions</span>
                                    </div>
                                </NavLink>
                            </div> */}

                            {/* <div className="menu-item-wrap disabled">
                                <div disabled className="menu-item disabled">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11.4999L11 13.4999L15.5 8.99987M20 11.9999C20 16.9083 14.646 20.4783 12.698 21.6147C12.4766 21.7439 12.3659 21.8085 12.2097 21.842C12.0884 21.868 11.9116 21.868 11.7903 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V7.21747C4 6.41796 4 6.0182 4.13076 5.67457C4.24627 5.37101 4.43398 5.10015 4.67766 4.8854C4.9535 4.64231 5.3278 4.50195 6.0764 4.22122L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999Z"></path></svg>
                                    <span>Subscriptions</span>
                                </div>
                            </div> */}


                            {/* <div className="horizontal-line"></div> */}

                            {/* <div className="menu-item-wrap">
                                <NavLink to="/guides-shortcuts/" className={({ isActive }) => isActive ? 'menu-item-link active' : 'menu-item-link'} onClick={() => handleClickMenuItem('guides')}>

                                    <div className="menu-item">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><path d="M11.5 5H11.9344C14.9816 5 16.5053 5 17.0836 5.54729C17.5836 6.02037 17.8051 6.71728 17.6702 7.39221C17.514 8.17302 16.2701 9.05285 13.7823 10.8125L9.71772 13.6875C7.2299 15.4471 5.98599 16.327 5.82984 17.1078C5.69486 17.7827 5.91642 18.4796 6.41636 18.9527C6.99474 19.5 8.51836 19.5 11.5656 19.5H12.5M8 5C8 6.65685 6.65685 8 5 8C3.34315 8 2 6.65685 2 5C2 3.34315 3.34315 2 5 2C6.65685 2 8 3.34315 8 5ZM22 19C22 20.6569 20.6569 22 19 22C17.3431 22 16 20.6569 16 19C16 17.3431 17.3431 16 19 16C20.6569 16 22 17.3431 22 19Z"></path></svg>
                                        <span>Guides & Shortcuts</span>
                                    </div>
                                </NavLink>
                            </div> */}

                            <div className="menu-item-wrap docs">
                                <a href="https://docs.dbdesign.io/" target="_blank">

                                    <div className="menu-item">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M16 13H8M16 17H8M10 9H8M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z"></path></svg>
                                        <span>Docs</span>
                                        <svg className="icon-new-tab" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M15 3h6v6"></path>
                                            <path d="M10 14 21 3"></path>
                                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                        </svg>
                                    </div>
                                </a>
                            </div>

                        </div>

                        <div className="dash-sidebar-bottom">
                            <div className={`menu-group ${isSidebarProfileMenuEnabled ? 'menu-group-hide' : ''}`}>

                                <div className="menu-item-wrap">
                                    {/* <NavLink to="/invite" className={({ isActive }) => isActive ? 'menu-item-link active' : 'menu-item-link'}> */}
                                    <div className={`menu-item-link ${isModalInvitePeopleEnabled ? 'active' : ''}`}>
                                        <div className="menu-item" onClick={openInvitePeopleModal}>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><path d="M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M19 21V15M16 18H22M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"></path></svg>
                                            <span>Invite Members</span>
                                        </div>
                                    </div>
                                    {/* </NavLink> */}
                                </div>

                                <div className="menu-item-wrap">
                                    <div className={`menu-item-link ${isModalPricingPlanUpgradeEnabled ? 'active' : ''}`}>
                                        <div className="menu-item upgrade" onClick={openUpgradePlanModal}>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11.4999L11 13.4999L15.5 8.99987M20 11.9999C20 16.9083 14.646 20.4783 12.698 21.6147C12.4766 21.7439 12.3659 21.8085 12.2097 21.842C12.0884 21.868 11.9116 21.868 11.7903 21.842C11.6341 21.8085 11.5234 21.7439 11.302 21.6147C9.35396 20.4783 4 16.9083 4 11.9999V7.21747C4 6.41796 4 6.0182 4.13076 5.67457C4.24627 5.37101 4.43398 5.10015 4.67766 4.8854C4.9535 4.64231 5.3278 4.50195 6.0764 4.22122L11.4382 2.21054C11.6461 2.13258 11.75 2.0936 11.857 2.07815C11.9518 2.06444 12.0482 2.06444 12.143 2.07815C12.25 2.0936 12.3539 2.13258 12.5618 2.21054L17.9236 4.22122C18.6722 4.50195 19.0465 4.64231 19.3223 4.8854C19.566 5.10015 19.7537 5.37101 19.8692 5.67457C20 6.0182 20 6.41796 20 7.21747V11.9999Z"></path></svg>
                                            <span>Upgrade Plan</span>
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="horizontal-line"></div> */}

                                <div className="menu-item-wrap">
                                    <NavLink to="/support-feedback/" className={({ isActive }) => isActive ? 'menu-item-link active' : 'menu-item-link'} onClick={() => handleClickMenuItem('feedback')}>
                                        <div className="menu-item">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="m4.93 4.93 4.24 4.24"></path><path d="m14.83 9.17 4.24-4.24"></path><path d="m14.83 14.83 4.24 4.24"></path><path d="m9.17 14.83-4.24 4.24"></path><circle cx="12" cy="12" r="4"></circle></svg>
                                            <span>Support & Feedback</span>
                                        </div>
                                    </NavLink>
                                </div>

                                <div className="menu-item-wrap">
                                    <NavLink to="/settings/" className={({ isActive }) => isActive ? 'menu-item-link active' : 'menu-item-link'} onClick={() => handleClickMenuItem('settings')}>
                                        <div className="menu-item">
                                            <svg
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                                stroke="currentColor"
                                                strokeWidth="2.3"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <path
                                                    d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                                                ></path>
                                                <path
                                                    d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z"
                                                ></path>
                                            </svg>

                                            <span>Settings</span>
                                        </div>
                                    </NavLink>
                                </div>

                                {/* <div className="menu-item-wrap">
                            <div className='menu-item-link'>
                                <div className="menu-item theme">
                                    <div className={`theme-item ${!isLightTheme ? 'selected' : ''}`} onClick={() => toggleTheme('dark')}>
                                        <ModeDarkIcon />
                                        <span>Dark</span>
                                    </div>
                                    <div className={`theme-item light ${isLightTheme ? 'selected' : ''}`}
                                    // onClick={() => { toggleTheme('light') }}
                                    >
                                        <ModeLightIcon />
                                        <span>Light</span>
                                    </div>


                                    {isSidebarCollapsed
                                        ? <div className={`theme-item selected collapsed`}
                                        // onClick={() => toggleTheme()}
                                        >
                                            {!isLightTheme ? <ModeDarkIcon /> : <ModeLightIcon />}
                                        </div>
                                        : ''
                                    }
                                </div>
                            </div>
                        </div> */}

                            </div>
                            {/* <div className="horizontal-line"></div> */}
                            <div className={`horizontal-line ${isSidebarProfileMenuEnabled ? 'horizontal-line-hide' : ''}`}></div>

                            <div
                                className={`dash-sidebar-profile ${isSidebarProfileMenuEnabled ? 'active' : ''}`}
                                onClick={toggleProfileMenu}
                            >
                                <div className="dash-sidebar-profile-avatar">
                                    {currentUser.image
                                        ? <img className="dash-sidebar-profile-avatar-img" src={currentUser.image} referrerPolicy="no-referrer" />
                                        : (currentUser?.name || currentUser?.email || 'U')[0].toUpperCase()
                                    }
                                </div>
                                <div className="dash-sidebar-profile-info">
                                    <span className="dash-sidebar-profile-name">{currentUser?.name || currentUser?.email}</span>
                                    {/* <span className="dash-sidebar-profile-email">{currentUser?.email}</span> */}
                                </div>
                                <svg className="dash-sidebar-profile-chevron" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="m7 15 5 5 5-5" /><path d="m7 9 5-5 5 5" />
                                </svg>
                            </div>
                        </div>

                    </div>
                </React.Fragment>
                : ''
            }

        </div>
    );
};

export default Sidebar;
